import React from "react"
import { COUNTRIES } from "./plannerQuery"

// The bar of To send and Waiting for answer: the queues read one country at a time (B3 pinned decision Q3), the country of the address.
export default function QueueBar({ query, onCountry, children }) {
  return <section className="ep-card ep-queue-bar" aria-label="Queue">
    <span className="ep-label">Country</span>
    <span className="ep-segment">{COUNTRIES.map(country => <button type="button" key={country} aria-pressed={query.country === country}
      className={"ep-chip" + (query.country === country ? " is-on" : "")} onClick={() => onCountry(country)}>{country}</button>)}</span>
    {children}
  </section>
}
